<template>
  <v-app style="background-color: black">
    <video
      autoplay
      muted
      loop
      id="myVideo"
      preload="auto"
      webkit-playsinline
      poster="@/assets/black.png"
    >
      <source src="@/assets/video/nightlife.mp4" type="video/mp4" />
    </video>
    <v-content class="video-content">
      <v-toolbar dark elevation="0" color="transparent">
        <v-slide-y-transition>
          <v-btn icon v-if="!isInit" @click="back">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-slide-y-transition>
      </v-toolbar>

      <v-row dense>
        <v-col class="text-center py-0">
          <div class="display-2 font-weight-regular">CLUBBERS</div>
        </v-col>
      </v-row>
      <v-container fluid style="max-width: 400px">
      <v-fade-transition>
        <router-view></router-view>
      </v-fade-transition>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
export default {
  computed: {
    isInit() {
      return this.$route.path == "/login/welcome";
    }
  },
  methods: {
    back() {
      this.$router.go(-1);
    }
  }
};
</script>
    <style lang="css" scoped>
/* Style the video: 100% width and height to cover the entire window */
#myVideo {
  position: fixed;
  right: 0;
  bottom: -10px;
  min-width: 100vw;
  min-height: calc(100vh + 10px);
}

/* Add some content at the bottom of the video/page */
.video-content {
  position: fixed;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  width: 100%;
  height: 100%;
  padding: 60px;
}

.video-content-bottom {
  bottom: 0;
  position: fixed;
  padding-bottom: 10px;
  margin: auto;
}
</style>